import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=bf2153e6&"
import script from "./schedule.vue?vue&type=script&lang=js&"
export * from "./schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports